//  export const baseUrl = "https://cloudbillingbeckend.onrender.com/";

  // export const baseUrl = "http://localhost:4000/";
//   export const baseUrl = "http://23.142.25.32:4000/";
  export const baseUrl = 
    process.env.REACT_APP_API_URL || 
    process.env.REACT_APP_BASE_URL || 
    "http://localhost:5000/";
//  export const baseUrl = "https://api.cloudrasoi.com/";

export const formatIndianCurrency = (amount) => {
  if (amount === undefined || amount === null || isNaN(amount)) return "0.00";
  return Number(amount).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
